import type { components } from "@/shared/api/auth.schema";

/** Every role hg-auth knows. One person can hold several; at most one staff role. */
export type UserRole = components["schemas"]["UserRole"];

/** The roles that open the control center. `client` and `nurse` do not. */
export const STAFF_ROLES = [
  "superadmin",
  "admin",
  "dispatcher",
] as const satisfies readonly UserRole[];
export type StaffRole = (typeof STAFF_ROLES)[number];

/**
 * The staff role the session acts with, as hg-auth says it (`staff_role`).
 * Null when there is none, and also when hg-auth has gained a role this
 * build does not know: an unknown role opens nothing.
 */
export function staffRoleOf(me: { staff_role?: string | null | undefined }): StaffRole | null {
  return STAFF_ROLES.find((role) => role === me.staff_role) ?? null;
}
